import axios from 'axios';

export default {
	
	pre_insertar(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
	},

	buscar_nombre(p_email, p_usuario, p_nombre) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.buscar_nombre",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_nombre": p_nombre
				  })
			})
	},

	buscar_por_id(p_email, p_usuario, p_poliza, p_rut, p_codigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.buscar_id",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_rut": p_rut,
					"p_codigo": p_codigo
				  })
			})
	},

	recuperar_persona(p_email, p_usuario, p_codigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_persona",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo
				  })
			})
	},

	recuperar_poliza(p_email, p_usuario, p_codigo, p_participa, p_fedesde, p_fehasta) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_poliza",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo,
					"p_participa": p_participa,
					"p_fedesde": p_fedesde,
					"p_fehasta": p_fehasta
				  })
			})
	},

	recuperar_detpoliza(p_email, p_usuario, p_poliza, p_item, p_endoso) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_detpoliza",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_item": p_item,
					"p_endoso": p_endoso
				  })
			})
	},

	recuperar_deuda(p_email, p_usuario, p_codigo, p_participa) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_deuda",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo,
					"p_participa": p_participa
				  })
			})
	},

	recuperar_detdeuda(p_email, p_usuario, p_codigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_detdeuda",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo
				  })
			})
	},

	recuperar_factura(p_email, p_usuario, p_factura) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_factura",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_factura": p_factura
				  })
			})
	},
	recuperar_detfactura(p_email, p_usuario, p_factura) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_detfactura",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_factura": p_factura
				  })
			})
	},

	recuperar_movimiento(p_email, p_usuario, p_movimiento) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_movimiento",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_movimiento": p_movimiento
				  })
			})
	},

	recuperar_detmovimiento(p_email, p_usuario, p_movimiento) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_detmovimiento",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_movimiento": p_movimiento
				  })
			})
	},

	recuperar_siniestro(p_email, p_usuario, p_codigo, p_participa) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_siniestro",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo,
					"p_participa": p_participa
				  })
			})
	},

	recuperar_detsiniestro(p_email, p_usuario, p_codigo, p_participa, p_poliza) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_detsiniestro",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo,
					"p_participa": p_participa,
					"p_poliza": p_poliza
				  })
			})
	},

	recuperar_liqsiniestro(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_liqsiniestro",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},
	
	recuperar_cumulo(p_email, p_usuario, p_codigo, p_participa, p_poliza) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_cumulo",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo,
					"p_participa": p_participa,
					"p_poliza": p_poliza
				  })
			})
	},

	recuperar_detcumulo(p_email, p_usuario, p_codigo, p_producto) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_detcumulo",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo,
					"p_producto": p_producto
				  })
			})
	},

	recuperar_lineasvig(p_email, p_usuario, p_codigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_lineasvig",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo
				  })
			})
	},

	recuperar_detlinea(p_email, p_usuario, p_nrosolici) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_detlinea",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_nrosolici": p_nrosolici
				  })
			})
	},

	recuperar_lineashist(p_email, p_usuario, p_codigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_lineashist",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo
				  })
			})
	},

	recuperar_moneda(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_moneda",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
	},
	
	recuperar_contragarantia(p_email, p_usuario, p_codigo, p_fedesde, p_fehasta) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_garpp_consultas.recuperar_contragarantia",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codigo": p_codigo,
					"p_fedesde": p_fedesde,
					"p_fehasta": p_fehasta
				  })
			})
	},
}